// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_i7-6";
export var emphasizeQuantity = "_i7-3";
export var flatBottomCorners = "_i7-5";
export var productImage = "_i7-0";
export var quantityContainer = "_i7-2";
export var tooltip = "_i7-1";
export var wrapAndEllipsesOverflow = "_i7-4";